import app from "./app";

export default {
  app,
};
